export default __webpack_public_path__ + "static/media/assignment_error.a0953c23.svg";